"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPermissionlessDelegatorTransaction = exports.AddPermissionlessValidatorTransaction = exports.TransformSupernetTransaction = exports.RemoveSupernetValidatorTransaction = exports.TransferSupernetOwnershipTransaction = exports.CreateChainTransaction = exports.CreateSupernetTransaction = exports.AddSupernetValidatorTransaction = exports.PlatformImportTransaction = exports.PlatformExportTransaction = exports.PlatformBaseTransaction = void 0;
const utils_1 = require("../../utils");
const constants_1 = require("../constants");
const output_1 = require("../output");
const transaction_1 = require("../transaction");
const types_1 = require("../types");
const supernet_1 = require("./supernet");
class PlatformBaseTransaction extends transaction_1.BaseTransaction {
    constructor(networkId, blockchainId, outputs, inputs, memo) {
        super(constants_1.PlatformBaseTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
    }
    static parse(data) {
        return transaction_1.BaseTransaction.parse(data, constants_1.PlatformBaseTransactionTypeId);
    }
}
exports.PlatformBaseTransaction = PlatformBaseTransaction;
class PlatformExportTransaction extends transaction_1.ExportTransaction {
    constructor(networkId, blockchainId, outputs, inputs, memo, destinationChain, exportedOutputs) {
        super(constants_1.PlatformExportTransactionTypeId, networkId, blockchainId, outputs, inputs, memo, destinationChain, exportedOutputs);
    }
    static parse(data) {
        return transaction_1.ExportTransaction.parse(data, constants_1.PlatformExportTransactionTypeId);
    }
}
exports.PlatformExportTransaction = PlatformExportTransaction;
class PlatformImportTransaction extends transaction_1.ImportTransaction {
    constructor(networkId, blockchainId, outputs, inputs, memo, sourceChain, importedInputs) {
        super(constants_1.PlatformImportTransactionTypeId, networkId, blockchainId, outputs, inputs, memo, sourceChain, importedInputs);
    }
    static parse(data) {
        return transaction_1.ImportTransaction.parse(data, constants_1.PlatformImportTransactionTypeId);
    }
}
exports.PlatformImportTransaction = PlatformImportTransaction;
class AddSupernetValidatorTransaction extends transaction_1.BaseTransaction {
    validator;
    supernetId;
    supernetAuth;
    constructor(networkId, blockchainId, outputs, inputs, memo, validator, supernetId, supernetAuth) {
        super(constants_1.AddSupernetValidatorTransactionType, networkId, blockchainId, outputs, inputs, memo);
        this.validator = validator;
        this.supernetId = supernetId;
        this.supernetAuth = supernetAuth;
    }
    getSignables() {
        return [...this.inputs, this.supernetAuth];
    }
    serialize() {
        const baseTransaction = super.serialize();
        const supernetAuthBytes = this.supernetAuth.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length + constants_1.ValidatorSize + constants_1.SupernetIdSize + supernetAuthBytes.length);
        buffer.write(baseTransaction);
        buffer.write(this.validator);
        buffer.write(this.supernetId);
        buffer.write(supernetAuthBytes);
        return buffer;
    }
    static parse(data) {
        const baseTx = transaction_1.BaseTransaction.parse(data, constants_1.AddSupernetValidatorTransactionType);
        const buffer = utils_1.JuneoBuffer.from(data);
        const reader = buffer.createReader();
        reader.skip(baseTx);
        const validator = supernet_1.Validator.parse(reader.read(constants_1.ValidatorSize));
        const supernetId = new types_1.SupernetId(reader.read(constants_1.SupernetIdSize).toCB58());
        const supernetAuth = supernet_1.SupernetAuth.parse(reader.readRemaining());
        return new AddSupernetValidatorTransaction(baseTx.networkId, baseTx.blockchainId, baseTx.outputs, baseTx.inputs, baseTx.memo, validator, supernetId, supernetAuth);
    }
}
exports.AddSupernetValidatorTransaction = AddSupernetValidatorTransaction;
class CreateSupernetTransaction extends transaction_1.BaseTransaction {
    rewardsOwner;
    constructor(networkId, blockchainId, outputs, inputs, memo, rewardsOwner) {
        super(constants_1.CreateSupernetTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.rewardsOwner = rewardsOwner;
    }
    getSupernetAuth(addresses) {
        return new supernet_1.SupernetAuth(addresses, this.rewardsOwner);
    }
    serialize() {
        const baseTransaction = super.serialize();
        const rewardsOwnerBytes = this.rewardsOwner.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length + rewardsOwnerBytes.length);
        buffer.write(baseTransaction);
        buffer.write(rewardsOwnerBytes);
        return buffer;
    }
    static parse(data) {
        const baseTx = transaction_1.BaseTransaction.parse(data, constants_1.CreateSupernetTransactionTypeId);
        const reader = utils_1.JuneoBuffer.from(data).createReader();
        reader.skip(baseTx);
        const rewardsOwner = output_1.Secp256k1OutputOwners.parse(reader.readRemaining());
        return new CreateSupernetTransaction(baseTx.networkId, baseTx.blockchainId, baseTx.outputs, baseTx.inputs, baseTx.memo, rewardsOwner);
    }
}
exports.CreateSupernetTransaction = CreateSupernetTransaction;
class CreateChainTransaction extends transaction_1.BaseTransaction {
    supernetId;
    name;
    chainAssetId;
    vmId;
    fxIds;
    genesisData;
    supernetAuth;
    constructor(networkId, blockchainId, outputs, inputs, memo, supernetId, name, chainAssetId, vmId, fxIds, genesisData, supernetAuth) {
        super(constants_1.CreateChainTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.supernetId = supernetId;
        this.name = name;
        this.chainAssetId = chainAssetId;
        this.vmId = vmId;
        this.fxIds = fxIds;
        this.genesisData = genesisData;
        this.supernetAuth = supernetAuth;
    }
    getSignables() {
        return [...this.inputs, this.supernetAuth];
    }
    serialize() {
        const baseTransaction = super.serialize();
        const supernetAuthBytes = this.supernetAuth.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length +
            constants_1.SupernetIdSize +
            2 +
            this.name.length +
            constants_1.AssetIdSize +
            constants_1.DynamicIdSize +
            4 +
            constants_1.DynamicIdSize * this.fxIds.length +
            4 +
            this.genesisData.length +
            supernetAuthBytes.length);
        buffer.write(baseTransaction);
        buffer.write(this.supernetId);
        buffer.writeUInt16(this.name.length);
        buffer.writeString(this.name);
        buffer.write(this.chainAssetId);
        buffer.write(this.vmId);
        buffer.writeUInt32(this.fxIds.length);
        for (const fxId of this.fxIds) {
            buffer.write(fxId);
        }
        buffer.writeUInt32(this.genesisData.length);
        buffer.writeString(this.genesisData);
        buffer.write(supernetAuthBytes);
        return buffer;
    }
    static parse(data) {
        const baseTx = transaction_1.BaseTransaction.parse(data, constants_1.CreateChainTransactionTypeId);
        const reader = utils_1.JuneoBuffer.from(data).createReader();
        reader.skip(baseTx);
        const supernetId = new types_1.SupernetId(reader.read(constants_1.SupernetIdSize).toCB58());
        const nameLength = reader.readUInt16();
        const name = reader.readString(nameLength);
        const chainAssetId = new types_1.AssetId(reader.read(constants_1.AssetIdSize).toCB58());
        const vmId = new types_1.DynamicId(reader.readString(constants_1.DynamicIdSize));
        const fxIdsLength = reader.readUInt32();
        const fxIds = [];
        for (let i = 0; i < fxIdsLength; i++) {
            fxIds.push(new types_1.DynamicId(reader.readString(constants_1.DynamicIdSize)));
        }
        const genesisDataLength = reader.readUInt32();
        const genesisData = reader.readString(genesisDataLength);
        const supernetAuth = supernet_1.SupernetAuth.parse(reader.readRemaining());
        return new CreateChainTransaction(baseTx.networkId, baseTx.blockchainId, baseTx.outputs, baseTx.inputs, baseTx.memo, supernetId, name, chainAssetId, vmId, fxIds, genesisData, supernetAuth);
    }
}
exports.CreateChainTransaction = CreateChainTransaction;
class TransferSupernetOwnershipTransaction extends transaction_1.BaseTransaction {
    supernetId;
    supernetAuth;
    owner;
    constructor(networkId, blockchainId, outputs, inputs, memo, supernetId, supernetAuth, owner) {
        super(constants_1.TransferSupernetOwnershipTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.supernetId = supernetId;
        this.supernetAuth = supernetAuth;
        this.owner = owner;
    }
    getSignables() {
        return [...this.inputs, this.supernetAuth];
    }
    serialize() {
        const baseTransaction = super.serialize();
        const supernetAuthBytes = this.supernetAuth.serialize();
        const ownerBytes = this.owner.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length + constants_1.SupernetIdSize + supernetAuthBytes.length + ownerBytes.length);
        buffer.write(baseTransaction);
        buffer.write(this.supernetId);
        buffer.write(supernetAuthBytes);
        buffer.write(ownerBytes);
        return buffer;
    }
    static parse(data) {
        const baseTx = transaction_1.BaseTransaction.parse(data, constants_1.TransferSupernetOwnershipTransactionTypeId);
        const reader = utils_1.JuneoBuffer.from(data).createReader();
        reader.skip(baseTx);
        const supernetId = new types_1.SupernetId(reader.read(constants_1.SupernetIdSize).toCB58());
        const supernetAuth = supernet_1.SupernetAuth.parse(reader.peekRemaining());
        reader.skip(supernetAuth);
        const owner = output_1.Secp256k1OutputOwners.parse(reader.readRemaining());
        return new TransferSupernetOwnershipTransaction(baseTx.networkId, baseTx.blockchainId, baseTx.outputs, baseTx.inputs, baseTx.memo, supernetId, supernetAuth, owner);
    }
}
exports.TransferSupernetOwnershipTransaction = TransferSupernetOwnershipTransaction;
class RemoveSupernetValidatorTransaction extends transaction_1.BaseTransaction {
    nodeId;
    supernetId;
    supernetAuth;
    constructor(networkId, blockchainId, outputs, inputs, memo, nodeId, supernetId, supernetAuth) {
        super(constants_1.RemoveSupernetValidatorTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.nodeId = nodeId;
        this.supernetId = supernetId;
        this.supernetAuth = supernetAuth;
    }
    getSignables() {
        return [...this.inputs, this.supernetAuth];
    }
    serialize() {
        const baseTransaction = super.serialize();
        const supernetAuthBytes = this.supernetAuth.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length + constants_1.NodeIdSize + constants_1.SupernetIdSize + supernetAuthBytes.length);
        buffer.write(baseTransaction);
        buffer.write(this.nodeId);
        buffer.write(this.supernetId);
        buffer.write(supernetAuthBytes);
        return buffer;
    }
    static parse(data) {
        const baseTx = transaction_1.BaseTransaction.parse(data, constants_1.RemoveSupernetValidatorTransactionTypeId);
        const reader = utils_1.JuneoBuffer.from(data).createReader();
        reader.skip(baseTx);
        const nodeId = new types_1.NodeId(reader.read(constants_1.NodeIdSize).toCB58());
        const supernetId = new types_1.SupernetId(reader.read(constants_1.SupernetIdSize).toCB58());
        const supernetAuth = supernet_1.SupernetAuth.parse(reader.peekRemaining());
        reader.skip(supernetAuth);
        return new RemoveSupernetValidatorTransaction(baseTx.networkId, baseTx.blockchainId, baseTx.outputs, baseTx.inputs, baseTx.memo, nodeId, supernetId, supernetAuth);
    }
}
exports.RemoveSupernetValidatorTransaction = RemoveSupernetValidatorTransaction;
class TransformSupernetTransaction extends transaction_1.BaseTransaction {
    supernetId;
    assetId;
    initialRewardPoolSupply;
    startRewardShare;
    startRewardTime;
    targetRewardShare;
    targetRewardTime;
    minValidatorStake;
    maxValidatorStake;
    minStakeDuration;
    maxStakeDuration;
    stakePeriodRewardShare;
    minDelegationFee;
    maxDelegationFee;
    minDelegatorStake;
    maxValidatorWeightFactor;
    uptimeRequirement;
    supernetAuth;
    constructor(networkId, blockchainId, outputs, inputs, memo, supernetId, assetId, initialRewardPoolSupply, startRewardShare, startRewardTime, targetRewardShare, targetRewardTime, minValidatorStake, maxValidatorStake, minStakeDuration, maxStakeDuration, stakePeriodRewardShare, minDelegationFee, maxDelegationFee, minDelegatorStake, maxValidatorWeightFactor, uptimeRequirement, supernetAuth) {
        super(constants_1.TransformSupernetTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.supernetId = supernetId;
        this.assetId = assetId;
        this.initialRewardPoolSupply = initialRewardPoolSupply;
        this.startRewardShare = startRewardShare;
        this.startRewardTime = startRewardTime;
        this.targetRewardShare = targetRewardShare;
        this.targetRewardTime = targetRewardTime;
        this.minValidatorStake = minValidatorStake;
        this.maxValidatorStake = maxValidatorStake;
        this.minStakeDuration = minStakeDuration;
        this.maxStakeDuration = maxStakeDuration;
        this.stakePeriodRewardShare = stakePeriodRewardShare;
        this.minDelegationFee = minDelegationFee;
        this.maxDelegationFee = maxDelegationFee;
        this.minDelegatorStake = minDelegatorStake;
        this.maxValidatorWeightFactor = maxValidatorWeightFactor;
        this.uptimeRequirement = uptimeRequirement;
        this.supernetAuth = supernetAuth;
    }
    getSignables() {
        return [...this.inputs, this.supernetAuth];
    }
    serialize() {
        const baseTransaction = super.serialize();
        const supernetAuthBytes = this.supernetAuth.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length +
            constants_1.SupernetIdSize +
            constants_1.AssetIdSize +
            8 +
            8 +
            8 +
            8 +
            8 +
            8 +
            8 +
            4 +
            4 +
            8 +
            4 +
            4 +
            8 +
            1 +
            4 +
            supernetAuthBytes.length);
        buffer.write(baseTransaction);
        buffer.write(this.supernetId);
        buffer.write(this.assetId);
        buffer.writeUInt64(this.initialRewardPoolSupply);
        buffer.writeUInt64(this.startRewardShare);
        buffer.writeUInt64(this.startRewardTime);
        buffer.writeUInt64(this.targetRewardShare);
        buffer.writeUInt64(this.targetRewardTime);
        buffer.writeUInt64(this.minValidatorStake);
        buffer.writeUInt64(this.maxValidatorStake);
        buffer.writeUInt32(this.minStakeDuration);
        buffer.writeUInt32(this.maxStakeDuration);
        buffer.writeUInt64(this.stakePeriodRewardShare);
        buffer.writeUInt32(this.minDelegationFee);
        buffer.writeUInt32(this.maxDelegationFee);
        buffer.writeUInt64(this.minDelegatorStake);
        buffer.writeUInt8(this.maxValidatorWeightFactor);
        buffer.writeUInt32(this.uptimeRequirement);
        buffer.write(supernetAuthBytes);
        return buffer;
    }
}
exports.TransformSupernetTransaction = TransformSupernetTransaction;
class AddPermissionlessValidatorTransaction extends transaction_1.BaseTransaction {
    validator;
    supernetId;
    signer;
    stake;
    validatorRewardsOwner;
    delegatorRewardsOwner;
    shares;
    constructor(networkId, blockchainId, outputs, inputs, memo, validator, supernetId, signer, stake, validatorRewardsOwner, delegatorRewardsOwner, shares) {
        super(constants_1.AddPermissionlessValidatorTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.validator = validator;
        this.supernetId = supernetId;
        this.signer = signer;
        this.stake = stake;
        this.stake.sort(output_1.TransferableOutput.comparator);
        this.validatorRewardsOwner = validatorRewardsOwner;
        this.delegatorRewardsOwner = delegatorRewardsOwner;
        this.shares = shares;
    }
    getOutputs() {
        const outputs = super.getOutputs();
        for (const output of this.stake) {
            outputs.push(output.output);
        }
        outputs.push(this.validatorRewardsOwner, this.delegatorRewardsOwner);
        return outputs;
    }
    serialize() {
        const baseTransaction = super.serialize();
        const signerBytes = this.signer.serialize();
        const stakeBytes = [];
        let stakeBytesSize = 0;
        for (const output of this.stake) {
            const bytes = output.serialize();
            stakeBytesSize += bytes.length;
            stakeBytes.push(bytes);
        }
        const validatorRewardsOwnerBytes = this.validatorRewardsOwner.serialize();
        const delegatorRewardsOwnerBytes = this.delegatorRewardsOwner.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length +
            constants_1.ValidatorSize +
            constants_1.SupernetIdSize +
            signerBytes.length +
            4 +
            stakeBytesSize +
            validatorRewardsOwnerBytes.length +
            delegatorRewardsOwnerBytes.length +
            4);
        buffer.write(baseTransaction);
        buffer.write(this.validator);
        buffer.write(this.supernetId);
        buffer.write(signerBytes);
        buffer.writeUInt32(this.stake.length);
        for (const output of stakeBytes) {
            buffer.write(output);
        }
        buffer.write(validatorRewardsOwnerBytes);
        buffer.write(delegatorRewardsOwnerBytes);
        buffer.writeUInt32(this.shares);
        return buffer;
    }
    static parse(data) {
        const baseTx = transaction_1.BaseTransaction.parse(data, constants_1.AddPermissionlessValidatorTransactionTypeId);
        const buffer = utils_1.JuneoBuffer.from(data);
        const reader = buffer.createReader();
        reader.skip(baseTx);
        const validator = supernet_1.Validator.parse(reader.read(constants_1.ValidatorSize));
        const supernetId = new types_1.SupernetId(reader.read(constants_1.SupernetIdSize).toCB58());
        const signer = supernet_1.PrimarySigner.parse(reader.read(constants_1.PrimarySignerSize));
        const stakeLength = reader.readUInt32();
        const stakes = [];
        for (let i = 0; i < stakeLength; i++) {
            const stake = output_1.TransferableOutput.parse(reader.peekRemaining());
            reader.skip(stake);
            stakes.push(stake);
        }
        const validatorRewardsOwner = output_1.Secp256k1OutputOwners.parse(reader.peekRemaining());
        reader.skip(validatorRewardsOwner);
        const delegatorRewardsOwner = output_1.Secp256k1OutputOwners.parse(reader.peekRemaining());
        reader.skip(delegatorRewardsOwner);
        const shares = reader.readUInt32();
        return new AddPermissionlessValidatorTransaction(baseTx.networkId, baseTx.blockchainId, baseTx.outputs, baseTx.inputs, baseTx.memo, validator, supernetId, signer, stakes, validatorRewardsOwner, delegatorRewardsOwner, shares);
    }
}
exports.AddPermissionlessValidatorTransaction = AddPermissionlessValidatorTransaction;
class AddPermissionlessDelegatorTransaction extends transaction_1.BaseTransaction {
    validator;
    supernetId;
    stake;
    delegatorRewardsOwner;
    constructor(networkId, blockchainId, outputs, inputs, memo, validator, supernetId, stake, delegatorRewardsOwner) {
        super(constants_1.AddPermissionlessDelegatorTransactionTypeId, networkId, blockchainId, outputs, inputs, memo);
        this.validator = validator;
        this.supernetId = supernetId;
        this.stake = stake;
        this.stake.sort(output_1.TransferableOutput.comparator);
        this.delegatorRewardsOwner = delegatorRewardsOwner;
    }
    getOutputs() {
        const outputs = super.getOutputs();
        for (const output of this.stake) {
            outputs.push(output.output);
        }
        outputs.push(this.delegatorRewardsOwner);
        return outputs;
    }
    serialize() {
        const baseTransaction = super.serialize();
        const stakeBytes = [];
        let stakeBytesSize = 0;
        for (const output of this.stake) {
            const bytes = output.serialize();
            stakeBytesSize += bytes.length;
            stakeBytes.push(bytes);
        }
        const delegatorRewardsOwnerBytes = this.delegatorRewardsOwner.serialize();
        const buffer = utils_1.JuneoBuffer.alloc(baseTransaction.length + constants_1.ValidatorSize + constants_1.SupernetIdSize + 4 + stakeBytesSize + delegatorRewardsOwnerBytes.length);
        buffer.write(baseTransaction);
        buffer.write(this.validator);
        buffer.write(this.supernetId);
        buffer.writeUInt32(this.stake.length);
        for (const output of stakeBytes) {
            buffer.write(output);
        }
        buffer.write(delegatorRewardsOwnerBytes);
        return buffer;
    }
    static parse(data) {
        const baseTx = transaction_1.BaseTransaction.parse(data, constants_1.AddPermissionlessDelegatorTransactionTypeId);
        const buffer = utils_1.JuneoBuffer.from(data);
        const reader = buffer.createReader();
        reader.skip(baseTx);
        const validator = supernet_1.Validator.parse(reader.read(constants_1.ValidatorSize));
        const supernetId = new types_1.SupernetId(reader.read(constants_1.SupernetIdSize).toCB58());
        const stakeLength = reader.readUInt32();
        const stakes = [];
        for (let i = 0; i < stakeLength; i++) {
            const stake = output_1.TransferableOutput.parse(reader.peekRemaining());
            reader.skip(stake);
            stakes.push(stake);
        }
        const rewardsOwner = output_1.Secp256k1OutputOwners.parse(reader.readRemaining());
        return new AddPermissionlessDelegatorTransaction(baseTx.networkId, baseTx.blockchainId, baseTx.outputs, baseTx.inputs, baseTx.memo, validator, supernetId, stakes, rewardsOwner);
    }
}
exports.AddPermissionlessDelegatorTransaction = AddPermissionlessDelegatorTransaction;
